import React from "react";
import { observer } from "mobx-react";
import { SignedEditionDndaWorkflowStateUpdateStore } from "../../store";
import { SignedEditionDndaWorkflowStateUpdateForm } from "./SignedEditionDndaWorkflowStateUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type SignedEditionDndaWorkflowStateUpdateProps = {
  signedEditionDndaWorkflowStateUpdateStore: SignedEditionDndaWorkflowStateUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SignedEditionDndaWorkflowStateUpdate: React.FC<SignedEditionDndaWorkflowStateUpdateProps> =
  observer(
    ({
      signedEditionDndaWorkflowStateUpdateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay
            open={signedEditionDndaWorkflowStateUpdateStore.isSaving}
          />
          <OutdatedAfterSaveNotice
            open={signedEditionDndaWorkflowStateUpdateStore.savedButOutdated}
            onReload={() =>
              signedEditionDndaWorkflowStateUpdateStore.reloadSignedEditionDndaWorkflowState()
            }
            reloadDisabled={
              signedEditionDndaWorkflowStateUpdateStore.isProcessing
            }
          />
          <SignedEditionDndaWorkflowStateUpdateForm
            signedEditionDndaWorkflowStateUpdateStore={
              signedEditionDndaWorkflowStateUpdateStore
            }
            name_esError={
              signedEditionDndaWorkflowStateUpdateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              signedEditionDndaWorkflowStateUpdateStore.setName_esValue(value);
            }}
            name_es={
              signedEditionDndaWorkflowStateUpdateStore.entityValues.name_es
            }
            name_enError={
              signedEditionDndaWorkflowStateUpdateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              signedEditionDndaWorkflowStateUpdateStore.setName_enValue(value);
            }}
            name_en={
              signedEditionDndaWorkflowStateUpdateStore.entityValues.name_en
            }
            name_ptError={
              signedEditionDndaWorkflowStateUpdateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              signedEditionDndaWorkflowStateUpdateStore.setName_ptValue(value);
            }}
            name_pt={
              signedEditionDndaWorkflowStateUpdateStore.entityValues.name_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={signedEditionDndaWorkflowStateUpdateStore.saveDisabled}
            onSave={() =>
              signedEditionDndaWorkflowStateUpdateStore.saveSignedEditionDndaWorkflowState()
            }
            onCancel={() =>
              signedEditionDndaWorkflowStateUpdateStore.cancelSignedEditionDndaWorkflowState()
            }
          />
          <ErrorDialog
            open={signedEditionDndaWorkflowStateUpdateStore.errorDialogOpened}
            title={signedEditionDndaWorkflowStateUpdateStore.errorTitle}
            description={
              signedEditionDndaWorkflowStateUpdateStore.errorDescription
            }
            onClose={() =>
              signedEditionDndaWorkflowStateUpdateStore.closeErrorDialog()
            }
          />
          <ConfirmCancelDialog
            open={signedEditionDndaWorkflowStateUpdateStore.confirmDialogOpened}
            title={signedEditionDndaWorkflowStateUpdateStore.confirmDialogTitle}
            description={
              signedEditionDndaWorkflowStateUpdateStore.confirmDialogDescription
            }
            onConfirm={() =>
              signedEditionDndaWorkflowStateUpdateStore.executeConfirmedAction()
            }
            onCancel={() =>
              signedEditionDndaWorkflowStateUpdateStore.closeConfirmDialog()
            }
          />
        </>
      );
    }
  );
